module.exports = __webpack_public_path__ + "static/media/about1.f76169ba.svg";